import { CircularProgress } from '@mui/material';
import { Suspense, lazy } from 'react';
import { RequireSchedulingAccess } from './RequireSchedulingAccess';

const SurgeryBoardPage = lazy(() =>
  import('../features/board').then((m) => ({ default: m.SurgeryBoardPage })),
);

const BlockSchedulePage = lazy(() =>
  import('../features/blockSchedule').then((m) => ({ default: m.BlockSchedulePage })),
);

/**
 * Lazy route element for the surgery board. Authorization (the Scheduling claim) is enforced by
 * the route-level `RequireSchedulingAccess` guard, which mounts `SurgeryBoardPage` — and its data
 * hooks — only for authorized users, so no content renders and no board query fires before the
 * guard evaluates (spec 091).
 */
export function SurgeryBoardRouteElement() {
  return (
    <RequireSchedulingAccess>
      <Suspense fallback={<CircularProgress data-testid="surgery-board-suspense-fallback" />}>
        <SurgeryBoardPage />
      </Suspense>
    </RequireSchedulingAccess>
  );
}

/**
 * Lazy route element for the block schedule. It reuses the board's `RequireSchedulingAccess` guard
 * — the same Scheduling claim — so no new access flag exists and nothing renders before the guard
 * evaluates (spec 200).
 */
export function BlockScheduleRouteElement() {
  return (
    <RequireSchedulingAccess>
      <Suspense fallback={<CircularProgress data-testid="block-schedule-suspense-fallback" />}>
        <BlockSchedulePage />
      </Suspense>
    </RequireSchedulingAccess>
  );
}
